import { AffichageDrComponent } from './affichage-dr.component';

export const AFFICHAGE_DR_ROUTES = [
    { path: '', component: AffichageDrComponent, data: { menu: { libelle: 'Données ProDouanes' } } },
    { path: ':annee', component: AffichageDrComponent }
];
